import { FileUpload } from 'primereact/fileupload';
import styled from 'styled-components';
import { borderRadius, borders, colourPalette, padding } from 'styles/styles';

export const FileUploadV2Style = {
  Container: styled.div`
    &.invalid {
      .p-fileupload-content {
        border: ${borders.borderSM} dashed ${colourPalette.rose500};
      }
    }
    &.disabled {
      .p-fileupload-content {
        border: ${borders.borderSM} dashed ${colourPalette.neutral300};
        pointer-events: none;
      }
      span {
        color: ${colourPalette.neutral300};
      }
    }
    .file-list-item-close {
      display: none;
    }
  `,
  FileUpload: styled(FileUpload)`
    .p-fileupload-buttonbar,
    .p-progressbar,
    .p-fileupload-choose {
      display: none;
    }
    .p-fileupload-content {
      border: ${borders.borderSM} dashed ${colourPalette.gray200};
      border-radius: ${borderRadius.roundedLG};
      padding: ${padding.paddingLG} ${padding.paddingXL};
    }
  `,
};
